import './index.css';
import logo from '../../logo.svg'
import { useNavigate } from 'react-router-dom'
import { useUser } from '../../contexts/UserContext'

function UserInfo(props) {

    let userInfo = props.userInfo
    if (!userInfo) {
        userInfo = {} 
    }

    const navigate = useNavigate()
    const { degradedMode } = useUser()

    const handleBindAccount = () => {
        navigate('/bind-account')
    }

    return (
        <div className='userinfo'>
            {/* G16: 降级模式提示条 */}
            {degradedMode && (
                <div className='degraded-banner'>
                    <span className='degraded-icon'>⚠️</span>
                    <span className='degraded-text'>通讯录权限未开启，部分功能受限</span>
                </div>
            )}
            <img className='avatar' src= {userInfo.avatar_url || logo} alt='' />
            <span className='name'>{ userInfo.name && userInfo.name.length > 0 ? '欢迎来到轻维管车' : ''}</span>
            {/* G14: 绑定状态快捷入口（⚠️ 2026-08-04 临时：默认全部显示已绑定） */}
            <div className='bind-status-entry' onClick={handleBindAccount}>
                <span className='bind-status-dot' style={{
                    background: '#34c759'
                }} />
                <span className='bind-status-label'>
                    已绑定
                </span>
            </div>
        </div>
    );
}

export default UserInfo;
